const ErrorMessage = ({ message }) => {
  if (Array.isArray(message)) {
    return (
      <>
        {message.map((m, i) => (
          <ErrorMessage key={`key${i}`} message={m} />
        ))}
      </>
    );
  } else {
    return <li>{message}</li>;
  }
};

export default ErrorMessage;
